import Swiper from 'swiper/bundle';

const REQUIRED_SLIDER_COUNT = 2;

class HighlightsCarousel {
  constructor(el) {
    this.el = el;
    this.slideEls = null;
    this.controlsEl = null;
    this.slideLength = 0;
    this.swiper = null;

    if (this.el) {
      this.initialize();
    }
  }

  initialize() {
    this.slideEls = this.el.querySelectorAll('.swiper-slide');
    this.controlsEl = this.el.querySelector('.js-carousel-controls');
    this.slideLength = this.slideEls.length;

    if (this.slideLength < REQUIRED_SLIDER_COUNT) {
      this.el.querySelector('.swiper-wrapper').dataset.slider = false;
      this.controlsEl.style.display = 'none';
      return;
    }

    this.swiper = new Swiper(this.el, {
      slidesPerView: 1,
      spaceBetween: 21,
      speed: 400,
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        prevEl: this.controlsEl.querySelector('.swiper-button-prev'),
        nextEl: this.controlsEl.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
      },
    });
  }
}

export default class Highlights {
  constructor(selector) {
    this.els = document.querySelectorAll(selector);
    this.instances = [];
    if (this.els) {
      this.initialize();
      this.bind();
    }
  }

  initialize() {
    this.els.forEach((el) => {
      const carouselEl = el.querySelector('.js-highlights-carousel');
      const carousel = new HighlightsCarousel(carouselEl);
      this.instances.push(carousel); // 各インスタンスを配列に追加
    });
  }

  bind() {
    // this.els を使って各 carousel コンテナにイベントをバインド
    this.els.forEach((carouselContainer) => {
      carouselContainer.addEventListener('click', this.onClickToggle.bind(this));
    });
  }

  /**
   * 自動再生の停止・開始
   */
  onClickToggle(e) {
    const target = e.target;

    // event target が再生・停止ボタンでない場合は処理しない
    if (!target.closest('.js-carousel-pause') && !target.closest('.js-carousel-play')) {
      return;
    }

    const instance = this.instances.find(instance => instance.uid === e.currentTarget.dataset.uid);
    const el = instance.swiper.el;
    const pauseButton = el.querySelector('.js-carousel-pause');
    const playButton = el.querySelector('.js-carousel-play');

    // 自動再生の状態に応じて停止・開始を切り替え
    if (instance.swiper.autoplay.running) {
      // 停止する
      instance.swiper.autoplay.stop();
      pauseButton.dataset.hidden = true;
      playButton.dataset.hidden = false;
    } else {
      // 再生する
      instance.swiper.autoplay.start();
      pauseButton.dataset.hidden = false;
      playButton.dataset.hidden = true;
    }
  }
}